var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSplit = function SvgArrowSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 12.75v-1.5h7.196L16.946 6H14V4.5h5.5V10H18V7.054l-5.696 5.696zM14 19.5V18h2.946l-3.527-3.496 1.085-1.085L18 16.946V14h1.5v5.5z"
  })));
};
export default SvgArrowSplit;